import * as React from 'react';
import { ResiliencyChromeAppContext } from 'Workspace/ChromeApp/ChromeAppContext';

export function useChromeApp() {
	return React.useContext(ResiliencyChromeAppContext);
}
